export default {"src":"https://static.jusbr.com/web/auth/_next/static/media/google.07e2a789.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};